var _g, _rect, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXls(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3159_69077)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 0C2.44772 0 2 0.447716 2 1V23C2 23.5523 2.44772 24 3 24H21C21.5523 24 22 23.5523 22 23V4L18 0H3Z",
    fill: "#E9F0FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0V4H22L18 0Z",
    fill: "#C2CDDE"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 10,
    width: 22,
    height: 10,
    rx: 1,
    fill: "#0F8105"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.82955 12.1818L7.1108 14.3125H7.15625L8.44318 12.1818H9.64489L7.85227 15.0909L9.6733 18H8.4517L7.15625 15.8835H7.1108L5.81534 18H4.59943L6.4375 15.0909L4.62216 12.1818H5.82955ZM10.4723 18V12.1818H11.5263V17.1165H14.0888V18H10.4723ZM18.1655 13.7812C18.139 13.5331 18.0272 13.34 17.8303 13.2017C17.6352 13.0634 17.3814 12.9943 17.0689 12.9943C16.8492 12.9943 16.6607 13.0275 16.5036 13.0938C16.3464 13.16 16.2261 13.25 16.1428 13.3636C16.0594 13.4773 16.0168 13.607 16.0149 13.7528C16.0149 13.8741 16.0424 13.9792 16.0973 14.0682C16.1541 14.1572 16.2308 14.233 16.3274 14.2955C16.424 14.3561 16.531 14.4072 16.6484 14.4489C16.7659 14.4905 16.8842 14.5256 17.0036 14.554L17.549 14.6903C17.7687 14.7415 17.9799 14.8106 18.1825 14.8977C18.3871 14.9848 18.5698 15.0947 18.7308 15.2273C18.8937 15.3598 19.0225 15.5199 19.1172 15.7074C19.2119 15.8949 19.2592 16.1146 19.2592 16.3665C19.2592 16.7074 19.1721 17.0076 18.9979 17.267C18.8236 17.5246 18.5717 17.7263 18.2422 17.8722C17.9145 18.0161 17.5178 18.0881 17.0518 18.0881C16.5992 18.0881 16.2062 18.018 15.8729 17.8778C15.5414 17.7377 15.282 17.5331 15.0945 17.2642C14.9089 16.9953 14.8085 16.6676 14.7933 16.2812H15.8303C15.8454 16.4839 15.9079 16.6525 16.0178 16.7869C16.1276 16.9214 16.2706 17.0218 16.4467 17.0881C16.6248 17.1544 16.8236 17.1875 17.0433 17.1875C17.2725 17.1875 17.4732 17.1534 17.6456 17.0852C17.8198 17.0152 17.9562 16.9186 18.0547 16.7955C18.1532 16.6705 18.2034 16.5246 18.2053 16.358C18.2034 16.2064 18.1589 16.0814 18.0717 15.983C17.9846 15.8826 17.8625 15.7992 17.7053 15.733C17.55 15.6648 17.3681 15.6042 17.1598 15.5511L16.4979 15.3807C16.0187 15.2576 15.6399 15.071 15.3615 14.821C15.085 14.5691 14.9467 14.2348 14.9467 13.8182C14.9467 13.4754 15.0395 13.1752 15.2251 12.9176C15.4126 12.66 15.6674 12.4602 15.9893 12.3182C16.3113 12.1742 16.6759 12.1023 17.0831 12.1023C17.496 12.1023 17.8577 12.1742 18.1683 12.3182C18.4808 12.4602 18.7261 12.6581 18.9041 12.9119C19.0821 13.1638 19.174 13.4536 19.1797 13.7812H18.1655Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3159_69077"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 24,
    fill: "white",
    transform: "translate(2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXls);
export default __webpack_public_path__ + "static/media/xls.d578ce800bb6364de535b8b4110b4e72.svg";
export { ForwardRef as ReactComponent };